import { isNull } from 'lodash';

export const getNestedComponents = (components: Array<any>) => {
  let openComponentIdx: number | null = null;
  let item;
  const nestedComponents: Array<any> = [];

  components.forEach((component, idx) => {
    const { type, ...props } = component;
    if (type === 'open') {
      item = props;
      openComponentIdx = idx;
    } else if (type === 'close' && !isNull(openComponentIdx)) {
      item.components = components.slice(openComponentIdx + 1, idx);
      nestedComponents.push(item);
      openComponentIdx = null;
    }
  });
  return nestedComponents;
};
